import { _T } from 'appI18n';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import appSettings from 'appSettings';
import React from 'react';
const useStyles = makeStyles({
    root: {
        // HACK: хак для отображения фильтра напротив заголовка секции.
        position: 'absolute',
        right: 0,
        top: -2
    }
});
export default function HotelRoomFilters(props) {
    var _a, _b;
    const classes = useStyles();
    const handleAvailabilityFilterChanged = (_, value) => {
        props.onFilterApplied(value);
    };
    return (React.createElement("div", { className: classes.root }, !appSettings().tourHideAvailabilityFilter ?
        React.createElement(FormControlLabel, { disabled: (_a = props.disabled) !== null && _a !== void 0 ? _a : false, label: _T.TOUR_ONLY_AVAILABLE, control: React.createElement(Checkbox, { disabled: (_b = props.disabled) !== null && _b !== void 0 ? _b : false, value: props.immediateConfirm, onChange: handleAvailabilityFilterChanged }) }) : null));
}
